import {
  CollectionTarget,
  DisplayMethod,
  SearchTarget,
  SearchType
} from '@/types'

export interface BibliographyContentSearchRequest {
  displayMethod: DisplayMethod
  searchTarget: SearchTarget
  numberOfLimit: number
  searchMethodAnd: boolean
  searchMethodSynonym: boolean
  searchMethodAllograph: boolean
  andSearchType: SearchType[]
  andCollectionTarget: CollectionTarget[]
  title: string
  contentTitle: string
  contentTitleNot: boolean
  contentAuthor: string
  contentAuthorNot: boolean
  contentAuthorNo: string
  contentAuthorNos: string[]
  holdingBranchCodes: string[]
}

export function BibliographyContentSearchRequestToJSON(
  value: BibliographyContentSearchRequest
): any {
  return {
    display_method: value.displayMethod ?? undefined,
    search_target: value.searchTarget ?? undefined,
    number_of_limit: value.numberOfLimit ?? undefined,
    search_method_and: value.searchMethodAnd ?? undefined,
    search_method_synonym: value.searchMethodSynonym ?? undefined,
    search_method_allograph: value.searchMethodAllograph ?? undefined,
    and_search_type:
      value.andSearchType.length !== 0 ? value.andSearchType : undefined,
    and_collection_target:
      value.andCollectionTarget.length !== 0
        ? value.andCollectionTarget
        : undefined,
    title: value.title !== '' ? value.title : undefined,
    content_title: value.contentTitle !== '' ? value.contentTitle : undefined,
    content_title_not:
      value.contentTitle !== '' ? value.contentTitleNot : undefined,
    content_author:
      value.contentAuthor !== '' && value.contentAuthorNo === ''
        ? value.contentAuthor
        : undefined,
    content_author_not:
      value.contentAuthor !== '' || value.contentAuthorNo !== ''
        ? value.contentAuthorNot
        : undefined,
    content_author_no:
      value.contentAuthorNo !== '' ? value.contentAuthorNo : undefined,
    content_author_nos:
      value.contentAuthorNos.length > 0 ? value.contentAuthorNos : undefined,
    holding_branch_codes:
      value.holdingBranchCodes.length !== 0
        ? value.holdingBranchCodes
        : undefined
  }
}
